export default "__VITE_ASSET__CkyiWEl7__"